export default {
  '发票开具确认': '发票开具确认',
  '常规订单': '常规订单',
  '订单号': '订单号',
  '展会': '展会',
  '展位号': '展位号',
  '开票金额': '开票金额',
  '商品名称': '商品名称',
  '金额': '金额',
  '数量': '数量',
  '费用减免': '费用减免',
  '退款金额': '退款金额',
  '余额': '余额',
  '付款识别码': '付款识别码',
  '现场缴费订单': '现场缴费订单',
  '以下为现场缴费订单，请正确填写付款识别码方可开具发票': '以下为现场缴费订单，请正确填写付款识别码方可开具发票',
  '注': '请填写付款识别码，未填写或填写错误则无法开具此类订单发票',
  '请输入展位号': '请输入展位号',
  '您还有未确认的现场订单': '您还有未确认的现场订单,是否重新确认?',
  '提示': '提示',
  '请选择有效的订单': '请选择有效的订单',
  '返回': '返回',
  '当前电子普票仅支持': '当前电子普票仅支持',
  '元以下的开票金额，超过限额请分批次申请': '元以下的开票金额，超过限额请分批次申请',
  '普通发票数量不足': '普通发票数量不足',
  '增值税专用发票数量不足': '增值税专用发票数量不足',

}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/invoiceConfirmation.js